import { defineComponent as _defineComponent } from 'vue'
import { ITheaterScreenNode } from '~/types/my-theater';
import ScreenNode from './ScreenNode.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionScreenNode',
  setup(__props) {

const promotionNode: ITheaterScreenNode = {
  currentUptimeSecs: 0,
  online: true,
  nodeId: '#01',
  filmLicenseId: 'none',
};

return { __sfc: true,promotionNode, ScreenNode }
}

})